<div [(ngpTabsetValue)]="selectedTab" ngpTabset class="flex flex-col">
  <div ngpTabList class="flex w-full items-center gap-8">
    @for (tab of tabs() | keyvalue; track tab.key) {
    <button
      ngpTabButton
      [ngpTabButtonValue]="tab.key"
      [class]="
        tab.key === selectedTab()
          ? 'button--style-primary-bordered-2 button--style-primary'
          : 'button--style-white-04'
      "
      class="button h-32 padding-x-12 rounded-4"
    >
      {{ tab.value.title }}
    </button>
    }
  </div>

  <div ngpTabPanel [ngpTabPanelValue]="selectedTab()">
    @if (storeResource.isLoading()) {
    <svg-icon
      class="absolute-center flex items-center justify-center s-14"
      src="assets/icons/ui/loading.svg"
      svgClass="loading-animation"
    ></svg-icon>
    } @else if (storeResource.error()) {
    <div
      style="text-align: center"
      class="flex flex-col gap-4 items-center justify-center w-full h-full"
    >
      {{ storeResource.error() }}
      <button
        class="button button--style-primary h-32 padding-x-12 rounded-4"
        (click)="storeResource.reload()"
      >
        Reload
      </button>
    </div>
    } @else if (storeResource.hasValue()) { @switch (selectedTab()) { @case
    ('Deposits') {
    <app-table
      [data]="store()['Deposits']"
      [columns]="userHistoryService.depositsColumns()"
      [(pagination)]="pagination"
    />
    } @case ('Trades') {
    <app-table
      [data]="store()['Trades']"
      [columns]="userHistoryService.tradesColumns()"
      [(pagination)]="pagination"
    />
    } @case ('Withdrawals') {
    <app-table
      [data]="store()['Withdrawals']"
      [columns]="userHistoryService.withdrawalsColumns()"
      [(pagination)]="pagination"
    />
    } @default {
    <div
      style="text-align: center"
      class="flex flex-col gap-4 items-center justify-center w-full h-full"
    >
      Something went wrong, please try again.
      <button
        class="button button--style-primary h-32 padding-x-12 rounded-4"
        (click)="storeResource.reload()"
      >
        Reload
      </button>
    </div>
    } } }
  </div>
</div>
